import gql from 'graphql-tag';

export default gql`
  mutation createAccountDeposit(
    $accountId: ID!
    $adjustedCostBasis: Float!
    $quantity: Float!
    $timeExecuted: String!
  ) {
    accountActivity: createAccountDeposit(
      accountId: $accountId
      adjustedCostBasis: $adjustedCostBasis
      quantity: $quantity
      timeExecuted: $timeExecuted
    ) {
      id
    }
  }
`;
